var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-view-img"},[_c('img',{staticClass:"custom-view-img",attrs:{"src":_vm.images,"alt":"Base64 Image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }